(ns iris.censors.views
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent :refer [atom]]
   [cljs.core.async :refer [go <!]]
   [iris.censors.events :as censors-events]
   [iris.censors.subs :as censors-subs]
   [iris.routes :as routes]
   [iris.events :as events]
   [iris.subs :as subs]
   [iris.utils :as utils]
   [iris.common :as common]
   [clojure.string :as string]
   [goog.functions :as gfn]
   [iris.hench :as hench]
  ;;  [iris.styles.general]
   [iris.route-scroll :as route-scroll]))



(def uniq-key (atom -1))
(defn gen-key []
  (swap! uniq-key inc))

;; (def selected-scope-raidized (reagent/atom nil))

;; this function in duplicated in screens and here
;; (defn set-selected-scope-raidized [scope]
;;   (if (hench/raidizable? scope)
;;     (go (reset! selected-scope-raidized (<! (hench/eid-to-raid scope))))
;;     (reset! selected-scope-raidized scope)))



;; new event handlers from screening - duplicated


(defn on-input-text-change
  ([e handler] (handler (.. e -target -value)))
  ([e handler & rest] (handler (.. e -target -value) rest)))

(def on-input-text-change-debounced (gfn/debounce on-input-text-change 1000))

(defn on-input-checkbox-change
  ([e] (.log js/console e))
  ([e handler]
   (println e)
   (handler (.. e -target -checked) (.. e -target -value)))
  ([e handler & rest]
   (println "rest:" rest (.. e -target -checked))
   (handler (.. e -target -checked) rest)))

(defn on-input-radio-change
  ([e] (println (.. e -target -value)))
  ([e handler & rest] (handler (.. e -target -value) rest)))

(defn on-input-select-change
  ([e] (println (.. e -target -value)))
  ([e handler] (handler (.. e -target -value)))
  ([e handler & rest] (handler (.. e -target -value) rest)))

(defn on-input-textarea-change [e handler]
  (println (.. e -target -value))
  (handler (.. e -target -value)))

(def on-input-textarea-change-debounced (gfn/debounce on-input-text-change 1000))

;; end - new event handlers from screening - duplicated




(def default-ferrors {:scopes_input false
                      :target_level false
                      :kind false
                      :pattern false
                      :target_fields false})

(def default-ferror-msgs {:scopes_input nil})

(def ferrors (atom default-ferrors))

(def ferror-msgs (atom default-ferror-msgs))

(defn reset-ferrors [default-ferrors default-ferror-msgs]
  (reset! ferrors default-ferrors)
  (reset! ferror-msgs default-ferror-msgs))




;; code for new event handlers

(defn target-level-errors
  ([target-level]
   (if (nil? target-level)
     (swap! ferrors assoc-in [:target_level] true)
     (swap! ferrors assoc-in [:target_level] false)))
  ([target-level1 target-level2]
   (if (and (false? target-level1) (false? target-level2))
     (swap! ferrors assoc-in [:target_level] true)
     (swap! ferrors assoc-in [:target_level] false))))


(defn target-level [checked value]
  (let [target-level1 (utils/is-input-checked "#target_level1")
        target-level2 (utils/is-input-checked "#target_level2")]
    (cond
      (and (true? target-level1) (true? target-level2))
      (re-frame/dispatch [::censors-events/set-censor-prop :target_level 0])
      (and (true? target-level1) (false? target-level2))
      (re-frame/dispatch [::censors-events/set-censor-prop :target_level 1])
      (and (false? target-level1) (true? target-level2))
      (re-frame/dispatch [::censors-events/set-censor-prop :target_level 2])
      (and (false? target-level1) (false? target-level2))
      (re-frame/dispatch [::censors-events/set-censor-prop :target_level nil]))
    (target-level-errors target-level1 target-level2)))


(defn scopes-input-errors [value]
  (when (and (not (:scopes_input @ferrors)) (empty? value))
    (swap! ferrors assoc-in [:scopes_input] true)
    (swap! ferror-msgs assoc-in [:scopes_input] "Scopes input is empty!"))
  (when (and (:scopes_input @ferrors) (not-empty value))
    (swap! ferrors assoc-in [:scopes_input] false)
    (swap! ferror-msgs assoc-in [:scopes_input] nil))
  (println @ferrors))


(defn scopes-input [value]
  (re-frame/dispatch-sync [::censors-events/set-censor-prop :scopes_input value])
  (scopes-input-errors value))


(defn pattern [value]
  (re-frame/dispatch [::censors-events/set-censor-prop :pattern value])
  (when (and (:pattern @ferrors) (not-empty value))
    (swap! ferrors assoc-in [:pattern] false)))


(defn adjust-pattern-matching-options [form-data]
  ;; "post selection" adjustments for pattern matching options
  (let [kind (:kind form-data)
        case-sensitive (:case_sensitive form-data)
        preserve-case (:preserve_case form-data)
        ignore-inserts (:ignore_inserts form-data)
        similar-chars (:similar_chars form-data)]
    (when (and (= case-sensitive true) (= preserve-case true))
      (re-frame/dispatch [::censors-events/set-censor-prop :case_sensitive false]))
    (when (or (and (= case-sensitive true) (= preserve-case true)) (= kind "regex"))
      (re-frame/dispatch [::censors-events/set-censor-prop :preserve_case false]))
    (when (or (and (= ignore-inserts true) (= similar-chars true)) (= kind "regex"))
      (re-frame/dispatch [::censors-events/set-censor-prop :ignore_inserts false]))
    (when (or (and (= ignore-inserts true) (= similar-chars true)) (= kind "regex"))
      (re-frame/dispatch [::censors-events/set-censor-prop :similar_chars false]))))


(defn pattern-matching-options [checked rest]
  ;; "param" is one of :case_sensitive, :preserve_case, :ignore_inserts, :similar_chars
  ;; "checked" is whether that param is checked (true false)
  ;; "form-data" contains all of options listed above
  (let [param (nth rest 0)
        form-data (nth rest 1)
        n-form-data (assoc form-data param checked)]
    (re-frame/dispatch [::censors-events/set-censor-prop param checked])
    (adjust-pattern-matching-options n-form-data)))


(defn kind [value rest]
  (let [form-data (nth rest 0)]
    (re-frame/dispatch [::censors-events/set-censor-prop :kind value])
    (when (and (:kind @ferrors) (not-empty value))
      (swap! ferrors assoc-in [:kind] false))
    (adjust-pattern-matching-options (assoc form-data :kind value))))


(defn autosub [_ rest]
  ;; note: first param is value but it is not boolean (string)
  (let [val (nth rest 0)]
    (re-frame/dispatch [::censors-events/set-censor-prop :autosub val])
    (when (= val true)
      (re-frame/dispatch [::censors-events/set-censor-prop :sub ""])
      (set! (.-value (js/document.getElementById "sub")) ""))))


(defn sub [value]
  (re-frame/dispatch [::censors-events/set-censor-prop :sub value]))


(defn disable-in-number [value rest]
  (re-frame/dispatch [::censors-events/set-censor-prop :disable-in-number (int value)])
  (let [form-data (first rest)
        diu (or (:disable-in-unit @form-data) "d")]
    (re-frame/dispatch [::censors-events/set-censor-prop :disable_in (str (int value) " " diu)])))


(defn disable-in-unit [value rest]
  (re-frame/dispatch [::censors-events/set-censor-prop :disable-in-unit value])
  (let [form-data (first rest)
        din (or (:disable-in-number @form-data) 0)]
    (re-frame/dispatch [::censors-events/set-censor-prop :disable_in (str din " " value)])))


(defn notes [value]
  (re-frame/dispatch [::censors-events/set-censor-prop :notes value]))

;; end - code for new event handlers


(defn censors-create-new-target-scopes-input [form-data]
  [:textarea#scopes.form-control
   {:key (str (:ruid @form-data)
              (:ts @form-data))
    :default-value (or (:scopes_input @form-data)
                       ".ALL")
    :style {:overflow "hidden"}
    ;; :size "60"
    :name "scopes"
    ;; :type "text"
    :ref (fn [el]
           (when el
             (utils/auto-grow-element el)))
    :on-change (fn [e]
                 (utils/auto-grow-element (.. e -target))
                 (on-input-textarea-change-debounced e scopes-input))}])


(defn censors-create-new-target-scopes-input-raidized [form-data]
  (let [raid-len @(re-frame/subscribe [::subs/raid-len])
        eids-raids (hench/eids-len-raids (:scopes @form-data) raid-len)
        scopes-input-raidized (hench/raidize-scopes-display
                               (:scopes @form-data)
                               (:scopes_input @form-data)
                               {:eids-raids eids-raids})
        scopes-display-raidized (hench/raidize-scopes-display
                                 (:scopes @form-data)
                                 (string/replace (:scopes_display @form-data) "censors" "censoring")
                                 {:eids-raids eids-raids})]
    [:<>
     [:input#scopes-raidized.form-control
      {:key (str (:ruid @form-data)
                 (:ts @form-data)
                 scopes-input-raidized)
       :default-value scopes-input-raidized
       :style {:margin "10px 0"}
       :size "60"
       :name "scopes-raidized"
       :type "text"
       :disabled true}]
     [:div
      {:style {:margin "10px 0"}
       :dangerouslySetInnerHTML
      ;;  {:__html
        (reagent/unsafe-html scopes-display-raidized)
        ;; }
       }]]))


(defn censors-create-new-target-scopes []
  ;; two cases here, one is when there is scopes_input and one when there is both scopes and scopes_input
  ;; (on edit - both scopes and scopes_input, on create new - scopes_input only)
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid :ts :scopes :scopes_input :scopes_display :target_level]])]
    [:div.form-group
     [:label {:key (:scopes_input @form-data)
              :for "scopes"
              :style {:display "block"
                      :margin-right 0}}
      "scopes:"
      (when (:ruid @form-data)
        [:span.cp-id {:style {:position "relative" :float "right"}}
         [:code
          [common/copier "copy full eid" (:scopes_input @form-data) "📋"]]])]
     [censors-create-new-target-scopes-input form-data]
     (when (:ruid @form-data)
       [censors-create-new-target-scopes-input-raidized form-data])
     [:div.form-text.text-muted
      [:span.text-danger "REQUIRED"]
      " - "
      [:small
       "List of ruids under where the post belongs. For example:\n\t\t\t\t\twebsite "
       [:code ".TLO"]
       ", forum "
       [:code "/acme.TLO"]
       ", thread "
       [:code "+abcdef"]
       ".\n\t\t\t\t\tThe censoring rule will only be applied to corresponding posts."
       [:br]
       [:code ".ALL"]
       " = all websites"]]]))


(defn censors-create-new-target-level []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:target_level]])]
    [:div.form-group
     [:input#target_level1.form-check-input
      {:checked (or (= (:target_level @form-data) 0)
                    (= (:target_level @form-data) 1))
       :value "1"
       :name "target_level1"
       :type "checkbox"
       :on-change (fn [e] (on-input-checkbox-change e target-level))}]
     [:label.form-check-label
      {:for "target_level1"}
      "OPs "
      [:span.text-muted "(level 1)"]]
     "\n\t\t\t\t \n\t\t\t\t"
     [:input#target_level2.form-check-input
      {:checked (or (= (:target_level @form-data) 0)
                    (= (:target_level @form-data) 2))
       :value "2"
       :name "target_level2"
       :type "checkbox"
       :on-change (fn [e] (on-input-checkbox-change e target-level))}]
     [:label.form-check-label
      {:for "target_level2"}
      "replies "
      [:span.text-muted "(level 2)"]]]))


(defn censors-create-new-target-scopes-error []
  (when (:scopes_input @ferrors)
    [:div {:class "alert alert-danger"} (:scopes_input @ferror-msgs)]))

(defn censors-create-new-target-level-error []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:target_level]])]
    (when (or (:target_level @ferrors) (nil? (:target_level @form-data)))
      [:div {:class "alert alert-danger"} "Neither target level is set! You must select at least one Target Post Level!"])))

(defn censors-create-new-target []
    [:div.panel.panel-default
     [:div.panel-heading "Target"]
     [:div.panel-body
      [censors-create-new-target-scopes]
      [:label "post level:"]
      [censors-create-new-target-level]
      [:div
       [censors-create-new-target-scopes-error]
       [censors-create-new-target-level-error]]]])


(defn censors-create-new-pattern []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid
                                                                      :kind
                                                                      :pattern
                                                                      :case_sensitive
                                                                      :preserve_case
                                                                      :ignore_inserts
                                                                      :similar_chars]])]
    [:div.panel.panel-default
     [:div.panel-heading "Pattern"]
     [:ul.list-group
      [:li.list-group-item
       [:div.form-check.form-check-inline
        [:input#kind_word.form-check-input
         {:checked (= (:kind @form-data) "word")
          :value "word"
          :name "kind"
          :type "radio"
          :on-change (fn [e] (on-input-radio-change e kind @form-data))}]
        [:label.form-check-label {:for "word"} "word"]
        [:input#kind_prefix.form-check-input
         {:checked (= (:kind @form-data) "prefix")
          :value "prefix"
          :name "kind"
          :type "radio"
          :on-change (fn [e] (on-input-radio-change e kind @form-data))}]
        [:label.form-check-label {:for "prefix"} "prefix"]
        [:input#kind_string.form-check-input
         {:checked (= (:kind @form-data) "string")
          :value "string"
          :name "kind"
          :type "radio"
          :on-change (fn [e] (on-input-radio-change e kind @form-data))}]
        [:label.form-check-label {:for "string"} "string"]
        [:input#kind_regex.form-check-input
         {:checked (= (:kind @form-data) "regex")
          :value "regex"
          :name "kind"
          :type "radio"
          :on-change (fn [e] (on-input-radio-change e kind @form-data))}]
        [:label.form-check-label {:for "regex"} "regex"]]
       [:div.form-group
        [:label {:for "pattern"} "pattern:"]
        [:input#pattern.form-control
         {:key (:ruid @form-data)
          :default-value (:pattern @form-data)
          :disabled (:ruid @form-data)
          :size "60"
          :name "pattern"
          :type "text"
          :on-change (fn [e] (on-input-text-change-debounced e pattern))}]]
       [:p.form-text "with the following matching options:"]
       [:div.form-group
        [:input#case_sensitive.form-check-input
         {:checked (= (:case_sensitive @form-data) true)
          :disabled (when (:preserve_case @form-data) true)
          :value "on"
          :name "case_sensitive"
          :type "checkbox"
          :on-change (fn [e] (on-input-checkbox-change e pattern-matching-options  :case_sensitive @form-data))}]
        [:label.form-check-label
         {:for "case_sensitive"}
         "case sensitive"]
        [:span.form-text.text-muted
         "(Matches UPPER/lower case exactly as in the pattern)"]]
       [:div.form-group
        [:input#preserve_case.form-check-input
         {:checked (= (:preserve_case @form-data) true)
          :disabled (when (or (= (:kind @form-data) "regex")
                              (= (:case_sensitive @form-data) true)) true)
          :value "on"
          :name "preserve_case"
          :type "checkbox"
          :on-change (fn [e] (on-input-checkbox-change e pattern-matching-options :preserve_case @form-data))}]
        [:label.form-check-label
         {:for "preserve_case"}
         "preserve casing"]
        [:span.form-text.text-muted
         "(UPPER/lower case of each letter in substitution string preserved; only available if \"case sensitive\" option is not checked)"]
        [:span.text-danger " — NO EFFECT ON REGEX PATTERNS"]]
       [:div.form-group
        [:input#ignore_inserts.form-check-input
         {:checked (= (:ignore_inserts @form-data) true)
          :disabled (when (or (= (:kind @form-data) "regex")
                              (when (:similar_chars @form-data) true)) true)
          :value "on"
          :name "ignore_inserts"
          :type "checkbox"
          :on-change (fn [e] (on-input-checkbox-change e pattern-matching-options :ignore_inserts @form-data))}]
        [:label.form-check-label
         {:for "ignore_inserts"}
         "ignore inserts"]
        [:span.form-text.text-muted
         "(Ignores any spaces or other non-alphanumeric characters inserted in pattern, e.g. "
         [:kbd "t'e s.t"]
         " would match pattern \"test\".)\n\t\t\t\t\t\t\t\t"
         [:span.text-danger " — NO EFFECT ON REGEX PATTERNS"]]]
       [:div.form-group
        [:input#similar_chars.form-check-input
         {:checked (= (:similar_chars @form-data) true)
          :disabled (when (or (= (:kind @form-data) "regex")
                              (= (:ignore_inserts @form-data) true)) true)
          :value "on"
          :name "similar_chars"
          :type "checkbox"
          :on-change (fn [e] (on-input-checkbox-change e pattern-matching-options :similar_chars @form-data))}]
        [:label.form-check-label
         {:for "similar_chars"}
         "similar characters"]
        [:span.form-text.text-muted
         "(Matches ivisually similar characters, e.g. \"b\" and \"6\"; \"I\", \"l\", and \"1\"; \"O\" and \"0\", etc.)\n\t\t\t\t\t\t\t\t"
         [:span.text-danger
          "  — NO EFFECT ON REGEX PATTERNS"]]]
       [:div
        (when (:kind @ferrors)
          [:div {:class "alert alert-danger"} "Kind not set!"])
        (when (:pattern @ferrors)
          [:div {:class "alert alert-danger"} "Pattern not entered!"])
        (when (:target_fields @ferrors)
          [:div {:class "alert alert-danger"} "Target fields not set!"])]]]]))


(defn censors-create-new-substitution []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid
                                                                      :re_sub
                                                                      :autosub
                                                                      :sub]])]
    [:div.panel.panel-default
     [:div.panel-heading "Substitution"]
     [:div.panel-body
      [:div.form-check
       (when-not (:re_sub @form-data)
         [:<>
          [:input.form-check-input
           {:checked (:autosub @form-data)
            :value "true"
            :name "autosub"
            :type "radio"
            :on-change (fn [e] (on-input-radio-change e autosub true))}]
          [:label.form-check-label {:for "autosub"} "autosub"]
          [:span.form-text.text-muted
           "(Generates a substitution string automatically by blanking out inner characters.)"]
          [:br] [:br]])

       [:input.form-check-input
        {:checked (not (:autosub @form-data))
         :value "false"
         :name "autosub"
         :type "radio"
         :on-change (fn [e] (on-input-radio-change e autosub false))
         }]
       [:label {:for "sub"} "substitution string:"]
       [:input#sub.form-control
        {:key (:ruid @form-data)
         :default-value (:sub @form-data)
         :size "60"
         :name "sub"
         :type "text"
         :disabled (:autosub @form-data)
         :on-change (fn [e] (on-input-text-change-debounced e sub))}]

       [:div.form-text.text-muted
        [:small
         "Use underscores (\"_\") for blanked out characters!"]]
       [:br]

       (when-let [re-sub (:re_sub @form-data)]
         [:<>
          [:label {:for "re_sub"} "substitution regex:"
           [:span.text-muted [:small " (Computed automatically)"]]]
          [:input#sub.form-control
           {:key re-sub
            :default-value re-sub
            :size "60"
            :name "re_sub"
            :type "text"
            :disabled true}]])]]]))


(defn censors-create-new-schedule []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:iso_disable_on
                                                                      :disable-in-unit
                                                                      :disable-in-number]])]
    [:div.panel.panel-default
     [:div.panel-heading "time period from creation until disabling"]
     [:div.panel-body
      [:div.form-inline
       (when (:iso_disable_on @form-data)
         [:div
          [:p {:style {:color "brown" :font-weight "bold"}} "Currently set to disable on: " (:iso_disable_on @form-data)]
          [:p "To set a new date, please enter it below:"]])
       [:div.input-group.mb-3
        [:div.input-group-addon
         {:aria-label "disable_in_number"}
         "turn off in:"]
        [:input#disable_in_number.form-control
         {:size "4"
          :name "disable_in_number"
          :type "text"
          :on-change (fn [e] (on-input-text-change-debounced e disable-in-number form-data))}]]
       [:select.form-control
        {:name "disable_in_unit"
         :default-value "d"
         :on-change (fn [e] (on-input-select-change e disable-in-unit form-data))}
        [:option {:value "d"} "days"]
        [:option {:value "w"} "weeks"]
        [:option {:value "mo"} "months"]
        [:option {:value "y"} "years"]]]
      [:div.form-text.text-muted
       [:small "Enter number only and select unit"]]]]))


(defn censors-create-new-notes []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:notes]])]
    [:div.panel.panel-default
     [:div.panel-heading "searchable notes for admin reference"]
     [:div.panel-body
      [:div.form-group
       [:label.form-check-label {:for "notes"} "notes:"]
       [:textarea#notes.form-control
        {:default-value (:notes @form-data)
         :cols "60"
         :rows "8"
         :name "notes"
         :on-change (fn [e] (on-input-textarea-change-debounced e notes))}]]]]))


(defn censors-create-new-breadcrumbs []
  [:nav
   {:aria-label "breadcrumb"}
   [:ol.breadcrumb
    [:li.breadcrumb-item [:a {:href "/"} "Iris"]]
    [:li.breadcrumb-item [:a {:href "/censoring"} "Censors"]]
    [:li.breadcrumb-item.active
     {:aria-current "page"}
     "Create New Censor"]]])


;; (defn censors-edit-breadcrumbs []
;;   (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid]])]
;;     [:nav
;;      {:aria-label "breadcrumb"}
;;      [:ol.breadcrumb
;;       [:li.breadcrumb-item [:a {:href "/"} "Iris"]]
;;       [:li.breadcrumb-item [:a {:href "/censoring"} "Censors"]]
;;       [:li.breadcrumb-item.active
;;        {:aria-current "page"}
;;        "Censor Details: " (:ruid @form-data)]]]))


(defn censors-edit-breadcrumbs []
  (reagent/create-class
   {:display-name  "censors-edit-breadcrumbs-component"
    :component-did-update
    (fn [this old-argv]
      (reagent/after-render route-scroll/after-render!))
    :reagent-render
    (fn []
      (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid]])]
        [:nav
         {:aria-label "breadcrumb"}
         [:ol.breadcrumb
          [:li.breadcrumb-item [:a {:href "/"} "Iris"]]
          [:li.breadcrumb-item [:a {:href "/censoring"} "Censors"]]
          [:li.breadcrumb-item.active
           {:aria-current "page"}
           "Censor Details: " (:ruid @form-data)]]]))}))


;; (defn <validate-form [form-data]
;;   (go
;;     ;; scopes input validation
;;     (let [scopes-input-raids-error (<! (hench/<validate-raids-from-scopes-expr (:scopes_input @form-data)))]
;;       (when-not (empty? scopes-input-raids-error)
;;         (swap! ferrors assoc-in [:scopes_input] true)
;;         (swap! ferror-msgs assoc-in [:scopes_input] (str "Raids do not exist in Firebase: " (string/join ", " scopes-input-raids-error))))

;;       (when (empty? (:scopes_input @form-data))
;;         (swap! ferrors assoc-in [:scopes_input] true)
;;         (swap! ferror-msgs assoc-in [:scopes_input] "Scopes input is empty!"))

;;       (when (and
;;              (not-empty (:scopes_input @form-data))
;;              (empty? scopes-input-raids-error)
;;              (:scopes_input @ferrors))
;;         (swap! ferrors assoc-in [:scopes_input] false)
;;         (swap! ferror-msgs assoc-in [:scopes_input] nil))


;;       ;; target level validation
;;       (when (nil? (:target_level @form-data))
;;         (swap! ferrors assoc-in [:target_level] true))
;;       (when (and (not (nil? (:target_level @form-data))) (:target_level @ferrors))
;;         (swap! ferrors assoc-in [:target_level] false))

;;       ;; kind validation
;;       (when (empty? (:kind @form-data))
;;         (swap! ferrors assoc-in [:kind] true))
;;       (when (and (not (empty? (:kind @form-data))) (:kind @ferrors))
;;         (swap! ferrors assoc-in [:kind] false))

;;       ;; pattern validation
;;       (when (empty? (:pattern @form-data))
;;         (swap! ferrors assoc-in [:pattern] true))
;;       (when (and (not-empty (:pattern @form-data)) (:pattern @ferrors))
;;         (swap! ferrors assoc-in [:pattern] false))

;;       (if (some true? (vals @ferrors)) false true))))

(defn validate-form [form-data]
    ;; scopes input validation
      (when (empty? (:scopes_input @form-data))
        (swap! ferrors assoc-in [:scopes_input] true)
        (swap! ferror-msgs assoc-in [:scopes_input] "Scopes input is empty!"))

      (when (and
             (not-empty (:scopes_input @form-data))
             (:scopes_input @ferrors))
        (swap! ferrors assoc-in [:scopes_input] false)
        (swap! ferror-msgs assoc-in [:scopes_input] nil))


      ;; target level validation
      (when (nil? (:target_level @form-data))
        (swap! ferrors assoc-in [:target_level] true))
      (when (and (not (nil? (:target_level @form-data))) (:target_level @ferrors))
        (swap! ferrors assoc-in [:target_level] false))

      ;; kind validation
      (when (empty? (:kind @form-data))
        (swap! ferrors assoc-in [:kind] true))
      (when (and (not (empty? (:kind @form-data))) (:kind @ferrors))
        (swap! ferrors assoc-in [:kind] false))

      ;; pattern validation
      (when (empty? (:pattern @form-data))
        (swap! ferrors assoc-in [:pattern] true))
      (when (and (not-empty (:pattern @form-data)) (:pattern @ferrors))
        (swap! ferrors assoc-in [:pattern] false))

      (if (some true? (vals @ferrors)) false true))


;; (defn <prep-create-form-data [form-data]
;;   (go
;;     (let [data @form-data
;;           scopes-input-unraidized (<! (hench/<unraidize (:scopes_input data)))]
;;       (merge {:ignore_inserts (:ignore_inserts data)
;;               :case_sensitive (:case_sensitive data)
;;               :enabled true
;;               :kind (:kind data)
;;               :notes (:notes data)
;;               :overwrite false
;;               :pattern (:pattern data)
;;               :preserve_case (:preserve_case data)
;;               :scopes_input scopes-input-unraidized
;;               :similar_chars (:similar_chars data)
;;               :autosub (:autosub data)
;;               :target_level (:target_level data)
;;               :target_fields (:target_fields data)}
;;              (when-let [disable_in (not-empty (:disable_in data))]
;;                {:disable_in disable_in})
;;              (when-let [sub (not-empty (:sub data))]
;;                {:sub sub})))))

(defn prep-create-form-data [form-data]
    (let [data @form-data]
      (merge {:ignore_inserts (:ignore_inserts data)
              :case_sensitive (:case_sensitive data)
              :enabled true
              :kind (:kind data)
              :notes (:notes data)
              :overwrite false
              :pattern (:pattern data)
              :preserve_case (:preserve_case data)
              :scopes_input (:scopes_input data)
              :similar_chars (:similar_chars data)
              :autosub (:autosub data)
              :target_level (:target_level data)
              :target_fields (:target_fields data)}
             (when-let [disable_in (not-empty (:disable_in data))]
               {:disable_in disable_in})
             (when-let [sub (not-empty (:sub data))]
               {:sub sub}))))



;; (defn <prep-update-form-data [form-data]
;;   (go
;;     (let [data @form-data
;;           scopes-input-unraidized (<! (hench/<unraidize (:scopes_input data)))]
;;       (merge {:ruid (:ruid data)
;;               :ignore_inserts (:ignore_inserts data)
;;               :case_sensitive (:case_sensitive data)
;;                                     ;;  :enabled true
;;               :kind (:kind data)
;;               :notes (:notes data)

;;               :pattern (:pattern data) ; can this be updated??
;;               :preserve_case (:preserve_case data)
;;               :scopes_input scopes-input-unraidized ; how does this work?
;;               :similar_chars (:similar_chars data)
;;                                     ;;  :autosub (:autosub data)
;;               :target_level (:target_level data)
;;                                     ;;  :target_fields (:target_fields data)
;;               }
;;              (when-let [disable_in (not-empty (:disable_in data))]
;;                {:disable_in disable_in})
;;              (when-let [sub (not-empty (:sub data))]
;;                {:sub sub})))))

(defn prep-update-form-data [form-data]
    (let [data @form-data]
      (merge {:ruid (:ruid data)
              :ignore_inserts (:ignore_inserts data)
              :case_sensitive (:case_sensitive data)
                                    ;;  :enabled true
              :kind (:kind data)
              :notes (:notes data)

              :pattern (:pattern data) ; can this be updated??
              :preserve_case (:preserve_case data)
              :scopes_input (:scopes_input data) ; how does this work?
              :similar_chars (:similar_chars data)
                                    ;;  :autosub (:autosub data)
              :target_level (:target_level data)
                                    ;;  :target_fields (:target_fields data)
              }
             (when-let [disable_in (not-empty (:disable_in data))]
               {:disable_in disable_in})
             (when-let [sub (not-empty (:sub data))]
               {:sub sub}))))


;; (defn on-submit [e form-data]
;;   (.preventDefault e)
;;   (go
;;     (when (= (<! (<validate-form form-data)) true)
;;       (let [preped-form-data (<! (<prep-create-form-data form-data))]
;;         (re-frame/dispatch [::censors-events/censor-create preped-form-data])))))

(defn on-submit [e form-data]
  (.preventDefault e)
    (when (= (validate-form form-data) true)
      (let [preped-form-data (prep-create-form-data form-data)]
        (re-frame/dispatch [::censors-events/censor-create preped-form-data]))))


;; (defn on-update [e form-data]
;;   (.preventDefault e)
;;   (go
;;     (when (= (<! (<validate-form form-data)) true)
;;       (let [preped-form-data (<! (<prep-update-form-data form-data))]
;;         (re-frame/dispatch [::censors-events/censor-update preped-form-data])))))

(defn on-update [e form-data]
  (.preventDefault e)
    (when (= (validate-form form-data) true)
      (let [preped-form-data (prep-update-form-data form-data)]
        (re-frame/dispatch [::censors-events/censor-update preped-form-data]))))


(defn submit-btn []
  (let [form-data (re-frame/subscribe [::censors-subs/form-data])]
    [:input.btn.btn-primary {:value "Submit"
                             :type "submit"
                             :disabled (:submitted @form-data)
                             :on-click (fn [e] (on-submit e form-data))}]))

(defn update-btn []
    (let [form-data (re-frame/subscribe [::censors-subs/form-data])]
      [:input.btn.btn-primary {:value "Update"
                               :type "submit"
                               :disabled (:submitted @form-data)
                               :on-click (fn [e] (on-update e form-data))}]))


(defn censors-form [mode roles]
  [:form
   [censors-create-new-target]
   [:div
    [:div.row
     [:div.col-lg-6
      [censors-create-new-pattern]]
     [:div.col-lg-6
      [censors-create-new-substitution]]]]
   [:div.form-text.lead.text-primary
    "Optional: schedule this censor to be disabled:"]
   [censors-create-new-schedule]
   [:div.form-text.lead.text-primary "Internal notes: :"]
   [censors-create-new-notes]
   (when (contains? @roles "censor")
     [:div.form-group
      (when (= mode "create")
        [submit-btn])
      (when (= mode "edit")
        [update-btn])])])


(defn censors-create-new [roles]
  [:<>
   [:div#page-body.container
    [censors-create-new-breadcrumbs]
    [:h1 "Create New Censor"]
    [:div#content
     [censors-form "create" roles]]]
   ])


;; (defn censors-create-new-panel []
;;   (reset-ferrors default-ferrors default-ferror-msgs)
;;   (let [qp (re-frame/subscribe [::subs/query-params])
;;         roles (re-frame/subscribe [::subs/roles])]
;;     (if-let [scope (:scope @qp)]
;;       (cond (hench/raidizable? scope)
;;             (go
;;               (let [raid (<! (hench/eid-to-raid scope))]
;;                 (re-frame/dispatch [::censors-events/reset-form-data {:scopes_input scope
;;                                                                       :scopes-input-raidized raid}])))
;;             :else
;;             (re-frame/dispatch [::censors-events/reset-form-data {:scopes_input scope}]))
;;       (re-frame/dispatch [::censors-events/reset-form-data]))
;;     [censors-create-new roles]))

(defn censors-create-new-panel []
  (reset-ferrors default-ferrors default-ferror-msgs)
  (let [roles (re-frame/subscribe [::subs/roles])]
    [censors-create-new roles]))


(defn censors-breadcrumbs-scope [scope]
  (let [raid-len (re-frame/subscribe [::subs/raid-len])
        raid (hench/eid-len-raid scope @raid-len)]
    [:<>
     [:li.breadcrumb-item [:a {:href "/censoring"} "Censors"]]
     [:li.breadcrumb-item.active "Scope: "
      [:code {:title raid} raid]]]))

(defn censors-breadcrumbs [query-params]
  [:nav
   {:aria-label "breadcrumb"}
   [:ol.breadcrumb
    [:li.breadcrumb-item [:a {:href "/"} "Iris"]]
    ;; [:li.breadcrumb-item.active {:aria-current "page"} "Censors"]

    (if-let [scope (:scope @query-params)]

      ;; [:<>
      ;;  [:li.breadcrumb-item [:a {:href "/censoring"} "Censors"]]
      ;;  [:li.breadcrumb-item.active "Scope: "
      ;;   [:code {:title @selected-scope-raidized} @selected-scope-raidized]]]
      [censors-breadcrumbs-scope scope]

      [:li.breadcrumb-item.active {:aria-current "page"} "Censors"])]])


(defn on-enable [e ruid]
  (let [checked (.. e -target -checked)]
    (if (true? checked)
      (re-frame/dispatch [::censors-events/http-enable-censor-rule ruid])
      (re-frame/dispatch [::censors-events/http-disable-censor-rule ruid]))))


(defn on-edit-enable [e ruid]
  (let [checked (.. e -target -checked)]
    (if (true? checked)
      (re-frame/dispatch [::censors-events/http-edit-enable-censor-rule ruid])
      (re-frame/dispatch [::censors-events/http-edit-disable-censor-rule ruid]))))


(defn on-delete [e ruid redirect]
  (.preventDefault e)
  (re-frame/dispatch [::censors-events/censor-delete ruid])
  (when redirect
    (re-frame/dispatch [::events/navigate :censors])))


;; (defn censors-table [data roles]
;;   (let [censor (contains? @roles "censor")]
;;     [:div.table-responsive
;;      [:table.table.table-striped.table-hover
;;       [:thead
;;        [:tr
;;         [:th.text-center "ID"]
;;         [:th.text-center "Scopes"]
;;         [:th.text-center "Kind"]
;;         [:th.text-center "Pattern"]
;;         [:th.text-center "Substitution"]
;;         [:th.text-center "On/Off"]
;;         [:th.text-center
;;          [:a {:href "?order=priority"} "Priority"]
;;          [:a {:href "#priority"} [:sup "*"]]]
;;         [:th.text-center "Created by"]
;;         [:th.text-center [:a {:href "?order=created"} "Created on"]]
;;         [:th.text-center "Notes"]
;;         (when censor [:th.text-center "Delete"])
;;         ]]
;;       [:tbody
;;     ;;  (for [[index d] (map-indexed vector @data)]
;;        (if (empty? @data)
;;          [:tr
;;           [:td {:colSpan 11 :style {:text-align "center"}} "No results"]]
;;          (for [d @data]
;;            [:tr {:key (gen-key) :id (:ruid d)}
;;             [:td.nowrap [:a {:href (str "/censoring/" (:ruid d))} (:ruid d)]]
;;             [:td
;;              {:class (when (not (:scopes-display-raidized d)) "short-eid")
;;               :dangerouslySetInnerHTML
;;               {:__html
;;                (or (:scopes-display-raidized d)
;;                    (hench/temp-prefix (:scopes d) (string/replace (:scopes_display d) "censors" "censoring")))}}]
;;             [:td (:kind d)]
;;             [:td {:title (str "regex: " (:re_pattern d))} (:pattern d)]
;;             [:td (:sub d)]
;;             [:td
;;              {:style {:text-align "center"}}
;;              (when (:iso_disable_on d)
;;                [:span.text-warning
;;                 {:title (str "Censor will be automatically disabled on " (:iso_disable_on d))
;;                  :style {:vertical-align "middle"
;;                          :margin-right "5px"
;;                          :display "block"
;;                          :margin-bottom "5px"}}
;;                 [:i.glyphicon.glyphicon-time]
;;                 "\n\t\t\t\t\t\t\t" (:disable_in d) "\n\t\t\t\t\t\t"])
;;              (when censor
;;                [:label {:class "switch"}
;;                 [:input {:type "checkbox"
;;                          :default-checked (:enabled d)
;;                          :on-change (fn [e] (on-enable e (:ruid d)))}]
;;                 [:span {:class "slider round"}]])]
;;             [:td.text-right (:priority d)]
;;             [:td.text-center (:uid_created_by d)]
;;             [:td (:iso_created_on d)]
;;             [:td
;;              [:i.glyphicon.glyphicon-pencil {:title (:notes d)}]]
;;             (when censor
;;               [:td.text-center
;;                [:a.btn.btn-danger
;;                 {:title "Click to permanently delete"
;;                  :on-click (fn [e] (on-delete e (:ruid d) false))}
;;                 [:i.glyphicon.glyphicon-remove]]])]))]]]))


(defn censors-table-td-scopes [d]
  (let [raid-len @(re-frame/subscribe [::subs/raid-len])
        eids-raids (hench/eids-len-raids (:scopes d) raid-len)
        scopes-display-raidized (hench/raidize-scopes-display
                                 (:scopes d)
                                 (string/replace (:scopes_display d) "censors" "censoring")
                                 {:eids-raids eids-raids})]
    [:td
     {;; :class (when (not (:scopes-display-raidized d)) "short-eid")
          ;; this class no longer needed 03/08/24
          ;; not only is it not needed it is wrong for it to be here at all
      :title (:scopes_input d)
      :dangerouslySetInnerHTML
      ;; {:__html
       (reagent/unsafe-html scopes-display-raidized)
      ;;  }
      }]))

(defn censors-table [data roles]
  (reagent/create-class
   {:display-name  "censors-table-component"
    :component-did-update
    (fn [this old-argv]
      (reagent/after-render route-scroll/after-render!))
    :reagent-render
    (fn [data roles]
      (let [censor (contains? @roles "censor")]
        [:div.table-responsive
         [:table.table.table-striped.table-hover
          [:thead
           [:tr
            [:th.text-center "ID"]
            [:th.text-center "Scopes"]
            [:th.text-center "Kind"]
            [:th.text-center "Pattern"]
            [:th.text-center "Substitution"]
            [:th.text-center "On/Off"]
            [:th.text-center
             [:a {:href "?order=priority"} "Priority"]
             [:a {:href "#priority"} [:sup "*"]]]
            [:th.text-center "Created by"]
            [:th.text-center [:a {:href "?order=created"} "Created on"]]
            [:th.text-center "Notes"]
            (when censor [:th.text-center "Delete"])]]
          [:tbody
          ;;  (for [[index d] (map-indexed vector @data)]
           (if (empty? @data)
             [:tr
              [:td {:colSpan 11 :style {:text-align "center"}} "No results"]]
             (for [d @data]
               [:tr {:key (gen-key) :id (:ruid d)}
                [:td.nowrap [:a {:href (str "/censoring/" (:ruid d))} (:ruid d)]]
                ;; [:td
                ;;  {:class (when (not (:scopes-display-raidized d)) "short-eid")
                ;;   :dangerouslySetInnerHTML
                ;;   {:__html
                ;;    (or (:scopes-display-raidized d)
                ;;        (hench/temp-prefix (:scopes d) (string/replace (:scopes_display d) "censors" "censoring")))}}]
                [censors-table-td-scopes d]
                [:td (:kind d)]
                [:td {:title (str "regex: " (:re_pattern d))} (:pattern d)]
                [:td (:sub d)]
                [:td
                 {:style {:text-align "center"}}
                 (when (:iso_disable_on d)
                   [:span.text-warning
                    {:title (str "Censor will be automatically disabled on " (:iso_disable_on d))
                     :style {:vertical-align "middle"
                             :margin-right "5px"
                             :display "block"
                             :margin-bottom "5px"}}
                    [:i.glyphicon.glyphicon-time]
                    "\n\t\t\t\t\t\t\t" (:disable_in d) "\n\t\t\t\t\t\t"])
                 (when censor
                   [:label {:class "switch"}
                    [:input {:type "checkbox"
                             :default-checked (:enabled d)
                             :on-change (fn [e] (on-enable e (:ruid d)))}]
                    [:span {:class "slider round"}]])]
                [:td.text-right (:priority d)]
                [:td.text-center (:uid_created_by d)]
                [:td (:iso_created_on d)]
                [:td
                 [:i.glyphicon.glyphicon-pencil {:title (:notes d)}]]
                (when censor
                  [:td.text-center
                   [:a.btn.btn-danger
                    {:title "Click to permanently delete"
                     :on-click (fn [e] (on-delete e (:ruid d) false))}
                    [:i.glyphicon.glyphicon-remove]]])]))]]]))}))




(defn on-search [e]
  (.preventDefault e)
  (let [val (.-value (.getElementById js/document "q"))]

    (when (empty? val)
      (.pushState js/history {} "" (routes/url-for :censors))
      (routes/dispatch {:handler :censors :query-params {}}))

    (when (not-empty val)
      (.pushState js/history {:q val} "" (str (routes/url-for :censors) "?q=" val))
      (routes/dispatch {:handler :censors :query-params {:q val}}))))


(defn on-click-create-new-censor [e]
  (re-frame/dispatch [::censors-events/reset-form-data]))


(defn censors-edit-header [roles]
  (let [form-data (re-frame/subscribe [::censors-subs/form-data-keys [:ruid
                                                                      :created_on_formatted
                                                                      :uid_created_by
                                                                      :updated_on_formatted
                                                                      :uid_updated_by
                                                                      :iso_disable_on
                                                                      :disable_on_formatted
                                                                      :itags
                                                                      :iso_disable_on
                                                                      :disable_in
                                                                      :enabled]])]
    [:div.row
     [:div.col-sm-8
      [:h1 "Censor " [:code (:ruid @form-data)]]
      [:ul
       [:li
        [:em.text-muted "created: "]
        (:created_on_formatted @form-data) "\n\t\t"
        [:em.text-muted "by "]
        (:uid_created_by @form-data)]
       [:li
        [:em.text-muted "updated: "]
        (:updated_on_formatted @form-data) "\n\t\t"
        [:em.text-muted "by "]
        (:uid_updated_by @form-data)]
       (when (:iso_disable_on @form-data)
         [:li.text-danger
          [:em.text-muted "disable scheduled for: "]
          (:disable_on_formatted @form-data)
          "\n\t\t"])
       (let [itags (:itags @form-data)]
         (when (not-empty itags)
           [:li.text-danger
            [:em.text-muted "tags: "]
            (for [i itags]
              [:a {:key i
                   :href (str "/censoring?q=tag:" (string/replace i "#" ""))} i "\n\t\t"])
            [:small.text-muted "(parsed from internal notes)"]
            "\n\t\t"]))]]
     [:div.col-sm-4 {:style {:text-align "right"
                             :min-height "90px"
                             :padding-top "30px"}}
      (when (:iso_disable_on @form-data)
        [:span.text-warning
         {:title (str "Censor will be automatically disabled on " (:iso_disable_on @form-data))
          :style {:vertical-align "middle"
                  :margin-right "5px"}}
         [:i.glyphicon.glyphicon-time]
         "\n\t\t\t\t\t\t\t" (:disable_in @form-data) "\n\t\t\t\t\t\t"])
      (when (contains? @roles "censor")
        [:<>
         [:label {:class "switch"
                  :style {:vertical-align "middle"
                          :margin-bottom 0}}
          [:input {:type "checkbox"
                   :checked (:enabled @form-data)
                   :on-change (fn [e] (on-edit-enable e (:ruid @form-data)))}]
          [:span {:class "slider round" :title "Enable/Disable Rule"}]]
         [:a.btn.btn-danger
          {:title "Click to permanently delete"
           :on-click (fn [e] (on-delete e (:ruid @form-data) true))
           :style {:vertical-align "middle"}}
          [:i.glyphicon.glyphicon-remove]]])]]))


(defn censors-edit [roles]
  [:<>
   [:div#page-body.container
    [censors-edit-breadcrumbs]
    [censors-edit-header roles]
    [:div#content
     [censors-form "edit" roles]]
    ;; [common/message ::censors-subs/message]
    ]])


(defn censors-edit-panel []
  (reset-ferrors default-ferrors default-ferror-msgs)
  (let [roles (re-frame/subscribe [::subs/roles])]
    [censors-edit roles]))


(defn censors-panel-h1-scope [scope]
  (let [raid-len (re-frame/subscribe [::subs/raid-len])
        raid (hench/eid-len-raid scope @raid-len)]
    [:h1 "Censors in scope: "
     [:code {:title raid} raid]]))

(defn censors-panel-h1-search-results [q]
  [:h1 "Censors search results:: \"" q "\""])

(defn censors-panel-h1 [query-params]
  (cond (:q @query-params)
        ;; [:h1 "Censors search results:: \"" (:q @query-params) "\""]
        [censors-panel-h1-search-results (:q @query-params)]
        (:scope @query-params)
        ;; [:h1 "Censors in scope: "
        ;;  [:code {:title @selected-scope-raidized} @selected-scope-raidized]]
        [censors-panel-h1-scope (:scope @query-params)]
        :else
        [:h1 "Censors"]))


(defn search-message []
  (let [query-params (re-frame/subscribe [::subs/query-params])
        meta (re-frame/subscribe [::censors-subs/meta])]
    (when-let [q (:q @query-params)]
      [:p "Total " (:n_found @meta) " result found. Search took " (:t_seconds @meta) " seconds."])))


(defn censors-create-new-btn [query-params]
  (let [roles @(re-frame/subscribe [::subs/roles])]
    (println "censors-create-new-btn" roles)
    (when (contains? roles "censor")
      (if-let [scope (:scope @query-params)]
        [:a.btn.btn-primary
         {:href (str "/censoring/create-new?scope=" scope "&kind=full")
          :on-click (fn [e] (on-click-create-new-censor e))}
         "Create New Censor"]
        [:a.btn.btn-primary
         {:href "/censoring/create-new"
          :on-click (fn [e] (on-click-create-new-censor e))}
         "Create New Censor"]))))


(defn censors-panel []
  (let [query-params (re-frame/subscribe [::subs/query-params])]
    ;; (when-let [scope (:scope @query-params)]
    ;;   (set-selected-scope-raidized scope))
    [:<>
     [:div#page-body.censors-section.container
      ;; [common/raid-cache-id-reset-btn]
      [censors-breadcrumbs query-params]
      [censors-panel-h1 query-params]
      [censors-create-new-btn query-params]
      [:div#content
       [:hr {:style {:display "block"}}]
       [:form.form-inline.mr-auto.screening-censoring-search-form
        [:input#q.form-control
         {:size "60"
          :name "q"
          :type "text"
          :default-value (:q @query-params)}]
        [:input.btn.btn-primary.ml-1 {:value "Search"
                                      :type "submit"
                                      :on-click (fn [e] (on-search e))}]]
       [search-message]
       [common/pager ::censors-subs/meta]

       (let [data (re-frame/subscribe [::censors-subs/data])
             roles (re-frame/subscribe [::subs/roles])]
         [censors-table data roles])

       [common/pager ::censors-subs/meta]
       [:div#priority.panel.panel-default
        [:div.panel-heading "Priority column"]
        [:div.panel-body.text-muted
         [:p
          "This defines the order in which the censors will be applied:\n\t\tHigher priority censoring rules are substituted before lower\n\t\tpriority ones."]
         [:p
          "By default, priority is equal to the length of the patern,\n\t\tso that longer patterns are substituted before short ones."]]]]
      ;; [common/message ::censors-subs/message]
      ]]))
